import { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { Panel } from 'primereact/panel';
import { Button } from 'primereact/button';
import { InputMask } from 'primereact/inputmask';
import { Tree, TreeCheckboxSelectionKeys, TreeMultipleSelectionKeys } from 'primereact/tree';
import { useGlobalState } from '../../../components/globalState/GlobalStateProvider';
import { FilterWeb } from '../../../interface/FilterWeb';
import { Fieldset } from 'primereact/fieldset';
import { PickList } from 'primereact/picklist';
import { RadioButton } from 'primereact/radiobutton';
import DegustacaoIcon from "./DegustacaoIcon";
import { Divider } from 'primereact/divider';
import getFiltroPermissao from '../../../service/getFiltroPermissao';
import { Calendar } from 'primereact/calendar';
import { Nullable } from 'primereact/ts-helpers';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';


export default function FiltroPF({
  onProcess,
  onClose,
  msgs
}: {
  onProcess: (filterWeb: FilterWeb, automotiva: boolean) => void
  onClose: () => void,
  msgs: any
}) {
  const { t } = useTranslation();
  const { state } = useGlobalState();
  const [cpf, setCpf] = useState<string>("");
  const [selectedKeys, setSelectedKeys] = useState<string | TreeMultipleSelectionKeys | TreeCheckboxSelectionKeys | null>(null);
  const [selectedOptionCheck, setSelectedOptionCheck] = useState<any[]>([]);
  const [targets, setTargets] = useState<any[]>([]);
  const [selectedFilter, setSelectedFilter] = useState<any>();
  const [opcionais, setOpcionais] = useState<any[]>([]);
  const [dataNascimento, setDataNascimento] = useState<Nullable<Date>>(null);
  const [options, setOptions] = useState<any[]>([]);
  const [filtros, setFiltros] = useState<any[]>([]);
  const [valorCartao, setValorCartao] = useState<number | null | undefined>(null);
  const [cartao, setCartao] = useState<string | null | undefined>(null);
  const [bin, setBin] = useState<string | null | undefined>(null);
  const [nome, setNome] = useState<string>("");
  const [validDocument, setValidDocument] = useState<boolean>(false)
  const [regiao, setRegiao] = useState<string | null>(null);
  const [uf, setUf] = useState<string | null>(null);
  const [cidade, setCidade] = useState<string | null>(null);
  const [cep, setCep] = useState<string | null>(null);
  const [endereco, setEndereco] = useState<string | null>(null);
  const [bairro, setBairro] = useState<string | null>(null);
  const [complemento, setComplemento] = useState<string | null>(null);
  const [dddTelefone, setDddTelefone] = useState<string | null>(null);
  const [tipoLogradouro, setTipoLogradouro] = useState<string | null>(null);
  const [numero, setNumero] = useState<string | null>(null);
  const [nomeMae, setNomeMae] = useState<string | null>(null);
  const [nomePai, setNomePai] = useState<string | null>(null);
  const [rg, setRg] = useState<string | null>(null);

  const validCPF = (documento: string) => {
    if (verifyCPF(documento)) {
      msgs.current?.clear();
      setValidDocument(true);
    }
    else {
      window.scrollTo(0, 0);
      setValidDocument(false);
      msgs.current?.clear();
      msgs.current?.show([
        { sticky: false, life: 100000, severity: 'error', summary: 'Erro', detail: 'Documento inválido', closable: false }

      ]);
    }

  }
  const ufs = [
    { name: 'Selecione', code: null },
    { name: 'AC', code: 'AC' },
    { name: 'AL', code: 'AL' },
    { name: 'AP', code: 'AP' },
    { name: 'AM', code: 'AM' },
    { name: 'BA', code: 'BA' },
    { name: 'CE', code: 'CE' },
    { name: 'ES', code: 'ES' },
    { name: 'GO', code: 'GO' },
    { name: 'MA', code: 'MA' },
    { name: 'MT', code: 'MT' },
    { name: 'MS', code: 'MS' },
    { name: 'MG', code: 'MG' },
    { name: 'PA', code: 'PA' },
    { name: 'PB', code: 'PB' },
    { name: 'PR', code: 'PR' },
    { name: 'PE', code: 'PE' },
    { name: 'PI', code: 'PI' },
    { name: 'RJ', code: 'RJ' },
    { name: 'RN', code: 'RN' },
    { name: 'RS', code: 'RS' },
    { name: 'RO', code: 'RO' },
    { name: 'RR', code: 'RR' },
    { name: 'SC', code: 'SC' },
    { name: 'SP', code: 'SP' },
    { name: 'SE', code: 'SE' },
    { name: 'TO', code: 'TO' }
  ];

  const regioesTrt = [
    { name: 'Selecione', code: null },
    { name: '1', code: '1' },
    { name: '2', code: '2' },
    { name: '3', code: '3' },
    { name: '4', code: '4' },
    { name: '5', code: '5' },
    { name: '6', code: '6' },
    { name: '7', code: '7' },
    { name: '8', code: '8' },
    { name: '9', code: '9' },
    { name: '10', code: '10' },
    { name: '11', code: '11' },
    { name: '12', code: '12' },
    { name: '13', code: '13' },
    { name: '14', code: '14' },
    { name: '15', code: '15' },
    { name: '16', code: '16' },
    { name: '17', code: '17' },
    { name: '18', code: '18' },
    { name: '19', code: '19' },
    { name: '20', code: '20' },
    { name: '21', code: '21' },
    { name: '22', code: '22' },
    { name: '23', code: '23' },
    { name: '24', code: '24' }
  ];

  const changeFilter = (value: any) => {

    getFiltroPermissao(value.key).then(async (data) => {
      await applyFiltros(options, data, value.key)
      await setFiltros(data);
      setSelectedKeys(null)
      value.filtros = data;
      setSelectedFilter(value);
      setOpcionais(createOptionsOpcionais(value))
    })
  }

  const verifyCPF = (strCPF: string) => {
    strCPF = strCPF.replaceAll('.', '').replace('-', '')
    let Soma;
    let Resto;
    Soma = 0;
    if (strCPF == "00000000000") return false;
    if (strCPF == "11111111111") return false;
    if (strCPF == "22222222222") return false;
    if (strCPF == "33333333333") return false;
    if (strCPF == "44444444444") return false;
    if (strCPF == "55555555555") return false;
    if (strCPF == "66666666666") return false;
    if (strCPF == "77777777777") return false;
    if (strCPF == "88888888888") return false;
    if (strCPF == "99999999999") return false;

    for (let i = 1; i <= 9; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
    Resto = (Soma * 10) % 11;

    if ((Resto == 10) || (Resto == 11)) Resto = 0;
    if (Resto != parseInt(strCPF.substring(9, 10))) return false;

    Soma = 0;
    for (let i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
    Resto = (Soma * 10) % 11;

    if ((Resto == 10) || (Resto == 11)) Resto = 0;
    if (Resto != parseInt(strCPF.substring(10, 11))) return false;
    return true;
  }

  const expandNode = (node: any, _expandedKeys: any) => {
    if (node.children && node.children.length) {
      _expandedKeys[node.key] = true;

      for (let child of node.children) {
        expandNode(child, _expandedKeys);
      }
    }
  };



  const createOptionsOpcionais = (opcao: any) => {
    const option: any[] = [];

    if (opcao.permissoes && opcao.permissoes.length > 0) {
      opcao.permissoes
        .sort((a: any, b: any) => {
          {
            if (!a.ordenacao) {
              return 1;
            }

            if (!b.ordenacao) {
              return -1;
            }

            if (a.ordenacao > b.ordenacao) {
              return 1;
            }
            if (a.ordenacao < b.ordenacao) {
              return -1;
            }
            return 0;
          }
        }).map((element: any) => {

          if (element.value == 'QUODPFINDICADORESNEGOCIO_PERFIL' ||
            element.value == 'QUODPFINDICADORESNEGOCIO_MERCADO' ||
            element.value == 'QUODPFINDICADORESNEGOCIO_GESTAO' ||
            element.value == 'QUODPFINDICADORESNEGOCIO_CENARIO' ||
            element.value == 'QUODPFINDICADORESNEGOCIO_PONTUALIDADE') {
            if (targets.filter((s) => s.value === element.value).length === 0) {
              targets.push({ value: element.value, target: [] })
            }
          }
          option.push({
            label: element.label, filtroPadrao: element.filtroPadrao, key: element.value, Collapse: true, pickList: targets.filter((s) => s.value === element.value).length != 0 ? element.permissoes : undefined, children: element.permissoes && targets.filter((s) => s.value === element.value).length === 0 ? createPermissoesOpcionaisFilhos(element.permissoes.filter((f: {
              tipoConsulta: string;
            }) => f.tipoConsulta === 'PF' || f.tipoConsulta === 'PFPJ'), false) : []
          });

        });
      expandAll(option)
    }
    return option;
  }

  const applyFiltros = (options: any, filtros: any, value: string) => {
    options.map((item: any) => {
      if (item.key === value) {
        item.filtros = filtros;
      }
      else {
        if (item.children && item.children.length > 0) {
          applyFiltros(item.children, filtros, value)
        }
      }

    })
  }

  const buscarFiltro = (value: any) => {
    if (Object.getOwnPropertyNames(value).length > 0) {
      const key = Object.getOwnPropertyNames(value)[Object.getOwnPropertyNames(value).length - 1]
      getFiltroPermissao(key).then((data) => {
        applyFiltros(opcionais, data, key)
      })
    }

  }

  const mensagemErroFiltro = (mensagem: string) => {
    window.scrollTo(0, 0);
    msgs.current?.clear();
    msgs.current?.show([
      { sticky: false, life: 100000, severity: 'error', summary: 'Erro', detail: mensagem, closable: false }

    ]);
  }

  const verifyObrigatorioMinimo = (filteWeb: FilterWeb, filtro: any) => {
    let retorno = true;
    if (filtros.length === 1) {
      return false;
    }
    filtros.filter((s1: any) => s1.tipoFiltro !== filtro.tipoFiltro && s1.obrigatorioMinimo).forEach((f: any) => {
      retorno = validFiltro(filteWeb, f);
      if (retorno) {
        return true;
      }
    })

    if (retorno) {
      return true;
    }
    else {
      return false;
    }
  }

  const validFiltro = (filteWeb: FilterWeb, filtro: any) => {

    if (filtro.tipoFiltro.includes("MAIS_NEGOCIO") && filtro.obrigatorio && !filteWeb.arrojado && !filteWeb.conservador && !filteWeb.usual) {
      return false;
    }
    if (filtro.tipoFiltro.includes("DATA_NASCIMENTO") && filtro.obrigatorio && !filteWeb.dataNascimento) {
      return false;
    }
    if (filtro.tipoFiltro === "NOME" && filtro.obrigatorio && !filteWeb.nome) {
      return false;
    }
    if (filtro.tipoFiltro.includes("REGIAO_TRT") && filtro.obrigatorio && !filteWeb.regiao) {
      return false;
    }
    if (filtro.tipoFiltro.includes("UF") && filtro.obrigatorio && !filteWeb.uf) {
      return false;
    }
    if (filtro.tipoFiltro.includes("CIDADE") && filtro.obrigatorio && !filteWeb.cidade) {
      return false;
    }
    if (filtro.tipoFiltro.includes("CEP") && filtro.obrigatorio && !filteWeb.cep) {
      return false;
    }
    if (filtro.tipoFiltro.includes("ENDERECO") && filtro.obrigatorio && !filteWeb.endereco) {
      return false;
    }
    if (filtro.tipoFiltro.includes("BAIRRO") && filtro.obrigatorio && !filteWeb.bairro) {
      return false;
    }
    if (filtro.tipoFiltro.includes("COMPLEMENTO") && filtro.obrigatorio && !filteWeb.complemento) {
      return false;
    }
    if (filtro.tipoFiltro.includes("DDD_TELEFONE") && filtro.obrigatorio && !filteWeb.dddTelefone) {
      return false;
    }
    if (filtro.tipoFiltro.includes("TIPO_LOGRADOURO") && filtro.obrigatorio && !filteWeb.tipoLogradouro) {
      return false;
    }
    if (filtro.tipoFiltro.includes("NUMERO") && filtro.obrigatorio && !filteWeb.numero) {
      return false;
    }
    if (filtro.tipoFiltro.includes("NOME_MAE") && filtro.obrigatorio && !filteWeb.nomeMae) {
      return false;
    }
    if (filtro.tipoFiltro.includes("NOME_PAI") && filtro.obrigatorio && !filteWeb.nomePai) {
      return false;
    }
    if (filtro.tipoFiltro.includes("RG") && filtro.obrigatorio && !filteWeb.rg) {
      return false;
    }
    return true;
  }

  const valid = (filteWeb: FilterWeb) => {
    if (filteWeb.consultas.length === 0) {
      mensagemErroFiltro('Opções de consulta obrigatório')
      return false;
    }
    let retorno = true;
    filtros.forEach((filtro: any) => {
      if (!validFiltro(filteWeb, filtro)) {
        if (!filtro.obrigatorioMinimo || !verifyObrigatorioMinimo(filteWeb, filtro)) {
          mensagemErroFiltro(filtro.descricao + ' obrigatório');
          retorno = false;
          return false;
        }
      }
    })


    return retorno;
  }


  const createPermissoesOpcionaisFilhos = (permissoes: any[], first: boolean) => {
    const option: any[] = [];
    if (permissoes) {
      permissoes
        .sort((a: any, b: any) => {
          {
            if (!a.ordenacao) {
              return 1;
            }

            if (!b.ordenacao) {
              return -1;
            }

            if (a.ordenacao > b.ordenacao) {
              return 1;
            }
            if (a.ordenacao < b.ordenacao) {
              return -1;
            }
            return 0;
          }
        })
        .forEach((element: {
          filtroPadrao: any;
          children: any; label: string; value: string; permissoes: any[]
        }) => {
          option.push({
            label: element.label, filtroPadrao: element.filtroPadrao, first: first, key: element.value, Collapse: true, pickList: targets.filter((s) => s.value === element.value).length != 0 ? element.permissoes : undefined, children: element.permissoes && targets.filter((s) => s.value === element.value).length === 0 ? createPermissoesOpcionaisFilhos(element.permissoes.filter((f: {
              tipoConsulta: string;
            }) => f.tipoConsulta === 'PF' || f.tipoConsulta === 'PFPJ'), false) : []
          });
        });
    }
    return option;
  }

  const createOptions = () => {
    const option: any[] = [];

    state.user.consultas.filter((f: {
      tipoConsulta: string;
    }) => f.tipoConsulta === 'PF' || f.tipoConsulta === 'PFPJ')
      .sort((a: any, b: any) => {
        {
          if (!a.ordenacao) {
            return 1;
          }

          if (!b.ordenacao) {
            return -1;
          }

          if (a.ordenacao > b.ordenacao) {
            return 1;
          }
          if (a.ordenacao < b.ordenacao) {
            return -1;
          }
          return 0;
        }
      })
      .map((element: any) => {
        const filhos = element.permissoes ? element.permissoes.filter((f: {
          tipoConsulta: string;
        }) => f.tipoConsulta === 'PF' || f.tipoConsulta === 'PFPJ') : [];
        if (filhos.length > 0) {
          option.push({ root: true, filtroPadrao: element.filtroPadrao, label: element.label, key: element.value, Collapse: true, children: createPermissoesFilhos(filhos, true) });
        }

      });
    expandAll(option)
    return option;
  }

  const createPermissoesFilhos = (permissoes: any[], first: boolean) => {
    const option: any[] = [];
    if (permissoes) {
      permissoes
        .sort((a: any, b: any) => {
          {
            if (!a.ordenacao) {
              return 1;
            }

            if (!b.ordenacao) {
              return -1;
            }

            if (a.ordenacao > b.ordenacao) {
              return 1;
            }
            if (a.ordenacao < b.ordenacao) {
              return -1;
            }
            return 0;
          }
        })
        .forEach((element: {
          filtroPadrao: any;
          children: any; label: string; value: string; permissoes: any[]
        }) => {
          if (element.value == 'QUODPFINDICADORESNEGOCIO_PERFIL' ||
            element.value == 'QUODPFINDICADORESNEGOCIO_MERCADO' ||
            element.value == 'QUODPFINDICADORESNEGOCIO_GESTAO' ||
            element.value == 'QUODPFINDICADORESNEGOCIO_CENARIO' ||
            element.value == 'QUODPFINDICADORESNEGOCIO_PONTUALIDADE') {
            if (targets.filter((s) => s.value === element.value).length === 0) {
              targets.push({ value: element.value, target: [] })
            }

          }
          option.push({ label: element.label, filtroPadrao: element.filtroPadrao, first: first, key: element.value, Collapse: true, pickList: targets.filter((s) => s.value === element.value).length != 0 ? element.permissoes : undefined, children: [], permissoes: element.permissoes });
        });
    }
    return option;
  }

  const expandAll = (option: any) => {
    let _expandedKeys = {};

    for (let node of option) {
      expandNode(node, _expandedKeys);
    }

    return _expandedKeys;
  };

  const processConsulta = () => {

    const opcoes: string[] = [];
    if (selectedFilter) {
      opcoes.push(selectedFilter.key);
    }
    if (selectedKeys && Object.getOwnPropertyNames(selectedKeys).length) {
      Object.getOwnPropertyNames(selectedKeys).map((item) => opcoes.push(item));
    }
    /* else{
      if(selectedFilter.permissoes && selectedFilter.permissoes.length > 0){
        window.scrollTo(0, 0);
        msgs.current?.clear();
          msgs.current?.show([
              { sticky: false, life: 100000, severity: 'error', summary: 'Erro', detail: 'Selecione pelo menos um opcional', closable: false }
            
          ]);
          return;
      }
    }*/
    let filterDefault;
    if (selectedFilter && selectedFilter.filtroPadrao) {
      filterDefault = JSON.parse(selectedFilter.filtroPadrao) ?? undefined
    }
    const indicadoresDefault: any[] = []
    if (filterDefault?.indicadores) {
      const target: any[] = []
      filterDefault?.indicadores.forEach((s: string) => target.push({ value: s }));
      indicadoresDefault.push({ value: selectedFilter.key, target: target })
    }

    selectedOptionCheck.map((item) => opcoes.push(item.value));
    const filteWeb: FilterWeb = {
      documento: cpf,
      consultas: opcoes,
      valor: null,
      arrojado: null,
      usual: null,
      nome: nome,
      conservador: null,
      cartao: cartao,
      bin: bin,
      regiao: regiao,
      uf: uf,
      cidade: cidade,
      cep: cep?.replace('-', '') ?? null,
      endereco: endereco,
      bairro: bairro,
      complemento: complemento,
      dddTelefone: dddTelefone?.replace(/\D/g, '') ?? null,
      valorCartao: valorCartao,
      dataNascimento: dataNascimento,
      tipoLogradouro: tipoLogradouro,
      numero: numero,
      nomeMae: nomeMae,
      nomePai: nomePai,
      rg: rg,
      indicadores: targets.filter((s: any) => opcoes.includes(s.value))
    };
    if (valid(filteWeb)) {
      onProcess(filteWeb, !cpf);
    }
  }
  const onChange = (event: any, key: string) => {
    const targetsOut = [{ value: key, target: event.target }]
    targets.filter((s: any) => s.value !== key).map((item: any) => targetsOut.push(item));
    setTargets(targetsOut)
  };
  const pickItemTemplate = (item: any) => {
    return (
      <div className="flex flex-wrap p-2 align-items-center gap-3">
        <div className="flex-1 flex flex-column gap-2">
          <span className="font-bold">{item.label}</span>
        </div>
      </div>
    );
  };
  const nodeTemplateRadio = (node: any, options: { className: string | undefined; }) => {
    let label = <div className='grid' style={{ alignItems: 'center' }}><RadioButton inputId={node.key} name="filter" value={node} onChange={(e) => changeFilter(e.value)} checked={selectedFilter?.key === node.key} />{selectedFilter?.key === node.key ? (<div style={{ paddingLeft: '0.5rem' }}>{nodeTemplate(node)}</div>) : (<label htmlFor={node.key} className="ml-2">{node.label}</label>)}{node.informativo && (<i data-pr-tooltip={node.informativo} data-pr-position="right" data-pr-at="right+5 top" style={{ paddingLeft: '1.5rem', color: '#183462', fontSize: '1.2rem' }} className="custom-target-icon pi pi-question-circle"></i>)}<DegustacaoIcon permissao={node.key} /></div>;
    if (node.children.length !== 0) {
      label = <b>{node.label}</b>;
    }

    return label;
  }
  const nodeTemplate = (node: any) => {
    let label = <span>{node.label}<DegustacaoIcon permissao={node.key} /></span>;
    if (node.children.length !== 0 || node.first) {
      label = <b className={node.root ? 'root' : ''} onClick={(e) => { if (node.root) { e.stopPropagation() } }}>{node.label}</b>;
    }

    let content: any = null;

    if (((selectedFilter && selectedFilter.key === node.key) || (selectedKeys && Object.getOwnPropertyNames(selectedKeys)?.includes(node.key))) && node.filtros && node.filtros.filter((s1: any) => s1.tipoFiltro === 'AUTENTICA_CARTAO').length > 0) {
      content = <>{content}
        {content && <br />}
        <div className="flex-auto">
          <label htmlFor="cartao" className="font-bold block mb-2 required">{t('cartao')}</label>
          <InputMask id="cartao" onChange={(e) => { setCartao(e.value); setValidDocument(true) }} mask='9999' size={4} maxLength={4} placeholder='Últimos 4 dígitos do cartão' />
        </div>
        <br />
        <div className="flex-auto">
          <label htmlFor="bin" className="font-bold block mb-2 required">{t('bin')}</label>
          <InputMask id="bin" onChange={(e) => { setBin(e.value); setValidDocument(true) }} size={9} maxLength={9} mask='999999?999' placeholder='Primeiros 6 a 9 dígitos do cartão' />
        </div>
        <br />
        <div className="flex-auto">
          <label htmlFor="currency" className="font-bold block mb-2">{t('valor')}</label>
          <InputNumber inputId="currency" onValueChange={(e) => { setValorCartao(e.value); setValidDocument(true) }} mode="currency" currency="BRL" locale="pt-BR" />
        </div>
      </>
    }

    if (((selectedFilter && selectedFilter.key === node.key) || (selectedKeys && Object.getOwnPropertyNames(selectedKeys)?.includes(node.key))) && node.filtros && node.filtros.filter((s1: any) => s1.tipoFiltro === 'NOME').length > 0) {
      content = <>{content}
        {content && <br />}
        <div className="flex-auto">
          <label htmlFor="nome" className="font-bold block mb-2">{t('nome')}</label>
          <InputText value={nome} onChange={(e) => { setNome(e.target.value); setValidDocument(true) }}
            placeholder="Digite Nome" />
        </div>
      </>
    }

    if (((selectedFilter && selectedFilter.key === node.key) || (selectedKeys && Object.getOwnPropertyNames(selectedKeys)?.includes(node.key))) && node.filtros && node.filtros.filter((s1: any) => s1.tipoFiltro === 'UF').length > 0) {
      content = <>{content}
        {content && <br />}
        <div className="flex-auto">
          <label htmlFor="uf" className="font-bold block mb-2">{t('uf')}</label>
          <Dropdown value={uf} onChange={(e) => { setUf(e.value); setValidDocument(true) }} options={ufs} optionLabel="name"
            placeholder="Selecione o Estado" optionValue='code' className="w-full md:w-14rem" />
        </div>
      </>
    }

    if (((selectedFilter && selectedFilter.key === node.key) || (selectedKeys && Object.getOwnPropertyNames(selectedKeys)?.includes(node.key))) && node.filtros && node.filtros.filter((s1: any) => s1.tipoFiltro === 'CIDADE').length > 0) {
      content = <>{content}
        {content && <br />}
        <div className="flex-auto">
          <label htmlFor="cidade" className="font-bold block mb-2">{t('cidade')}</label>
          <InputText value={cidade} onChange={(e) => { setCidade(e.target.value); setValidDocument(true) }}
            placeholder="Digite Cidade" />
        </div>
      </>
    }

    if (((selectedFilter && selectedFilter.key === node.key) || (selectedKeys && Object.getOwnPropertyNames(selectedKeys)?.includes(node.key))) && node.filtros && node.filtros.filter((s1: any) => s1.tipoFiltro === 'CEP').length > 0) {
      content = <>{content}
        {content && <br />}
        <div className="flex-auto">
          <label htmlFor="cep" className="font-bold block mb-2">{t('cep')}</label>
          <InputMask id="cep" value={cep} onChange={(e) => { setCep(e.value ?? null); setValidDocument(true) }} mask="99999-999"
            placeholder="99999-999" />
        </div>
      </>
    }

    if (((selectedFilter && selectedFilter.key === node.key) || (selectedKeys && Object.getOwnPropertyNames(selectedKeys)?.includes(node.key))) && node.filtros && node.filtros.filter((s1: any) => s1.tipoFiltro === 'ENDERECO').length > 0) {
      content = <>{content}
        {content && <br />}
        <div className="flex-auto">
          <label htmlFor="endereco" className="font-bold block mb-2">{t('endereco')}</label>
          <InputText value={endereco ?? ''} onChange={(e) => { setEndereco(e.target.value); setValidDocument(true) }}
            placeholder="Digite Endereço" />
        </div>
      </>
    }

    if (((selectedFilter && selectedFilter.key === node.key) || (selectedKeys && Object.getOwnPropertyNames(selectedKeys)?.includes(node.key))) && node.filtros && node.filtros.filter((s1: any) => s1.tipoFiltro === 'TIPO_LOGRADOURO').length > 0) {
      content = <>{content}
        {content && <br />}
        <div className="flex-auto">
          <label htmlFor="tipoLogradouro" className="font-bold block mb-2">{t('tipoLogradouro')}</label>
          <InputText value={tipoLogradouro ?? ''} onChange={(e) => { setTipoLogradouro(e.target.value); setValidDocument(true) }}
            placeholder="Ex: Rua, Avenida, Alameda" />
        </div>
      </>
    }

    if (((selectedFilter && selectedFilter.key === node.key) || (selectedKeys && Object.getOwnPropertyNames(selectedKeys)?.includes(node.key))) && node.filtros && node.filtros.filter((s1: any) => s1.tipoFiltro === 'NUMERO').length > 0) {
      content = <>{content}
        {content && <br />}
        <div className="flex-auto">
          <label htmlFor="numero" className="font-bold block mb-2">{t('numero')}</label>
          <InputText value={numero ?? ''} onChange={(e) => { setNumero(e.target.value); setValidDocument(true) }}
            placeholder="Digite Número" />
        </div>
      </>
    }

    if (((selectedFilter && selectedFilter.key === node.key) || (selectedKeys && Object.getOwnPropertyNames(selectedKeys)?.includes(node.key))) && node.filtros && node.filtros.filter((s1: any) => s1.tipoFiltro === 'NOME_MAE').length > 0) {
      content = <>{content}
        {content && <br />}
        <div className="flex-auto">
          <label htmlFor="nomeMae" className="font-bold block mb-2">{t('nomeMae')}</label>
          <InputText value={nomeMae ?? ''} onChange={(e) => { setNomeMae(e.target.value); setValidDocument(true) }}
            placeholder="Digite Nome da Mãe" />
        </div>
      </>
    }

    if (((selectedFilter && selectedFilter.key === node.key) || (selectedKeys && Object.getOwnPropertyNames(selectedKeys)?.includes(node.key))) && node.filtros && node.filtros.filter((s1: any) => s1.tipoFiltro === 'NOME_PAI').length > 0) {
      content = <>{content}
        {content && <br />}
        <div className="flex-auto">
          <label htmlFor="nomePai" className="font-bold block mb-2">{t('nomePai')}</label>
          <InputText value={nomePai ?? ''} onChange={(e) => { setNomePai(e.target.value); setValidDocument(true) }}
            placeholder="Digite Nome do Pai" />
        </div>
      </>
    }

    if (((selectedFilter && selectedFilter.key === node.key) || (selectedKeys && Object.getOwnPropertyNames(selectedKeys)?.includes(node.key))) && node.filtros && node.filtros.filter((s1: any) => s1.tipoFiltro === 'RG').length > 0) {
      content = <>{content}
        {content && <br />}
        <div className="flex-auto">
          <label htmlFor="rg" className="font-bold block mb-2">{t('rg')}</label>
          <InputText value={rg ?? ''} onChange={(e) => { setRg(e.target.value); setValidDocument(true) }}
            placeholder="Digite RG" />
        </div>
      </>
    }

    if (((selectedFilter && selectedFilter.key === node.key) || (selectedKeys && Object.getOwnPropertyNames(selectedKeys)?.includes(node.key))) && node.filtros && node.filtros.filter((s1: any) => s1.tipoFiltro === 'BAIRRO').length > 0) {
      content = <>{content}
        {content && <br />}
        <div className="flex-auto">
          <label htmlFor="bairro" className="font-bold block mb-2">{t('bairro')}</label>
          <InputText value={bairro ?? ''} onChange={(e) => { setBairro(e.target.value); setValidDocument(true) }}
            placeholder="Digite Bairro" />
        </div>
      </>
    }

    if (((selectedFilter && selectedFilter.key === node.key) || (selectedKeys && Object.getOwnPropertyNames(selectedKeys)?.includes(node.key))) && node.filtros && node.filtros.filter((s1: any) => s1.tipoFiltro === 'COMPLEMENTO').length > 0) {
      content = <>{content}
        {content && <br />}
        <div className="flex-auto">
          <label htmlFor="complemento" className="font-bold block mb-2">{t('complemento')}</label>
          <InputText value={complemento ?? ''} onChange={(e) => { setComplemento(e.target.value); setValidDocument(true) }}
            placeholder="Digite Complemento" />
        </div>
      </>
    }

    if (((selectedFilter && selectedFilter.key === node.key) || (selectedKeys && Object.getOwnPropertyNames(selectedKeys)?.includes(node.key))) && node.filtros && node.filtros.filter((s1: any) => s1.tipoFiltro === 'DDD_TELEFONE').length > 0) {
      content = <>{content}
        {content && <br />}
        <div className="flex-auto">
          <label htmlFor="dddTelefone" className="font-bold block mb-2">{t('dddTelefone')}</label>
          <InputMask id="dddTelefone" value={dddTelefone} onChange={(e) => { setDddTelefone(e.value ?? null); setValidDocument(true) }} mask="(99) 99999-9999"
            placeholder="(99) 99999-9999" />
        </div>
      </>
    }

    if (((selectedFilter && selectedFilter.key === node.key) || (selectedKeys && Object.getOwnPropertyNames(selectedKeys)?.includes(node.key))) && node.filtros && node.filtros.filter((s1: any) => s1.tipoFiltro === 'REGIAO_TRT').length > 0) {
      content = <>{content}
        {content && <br />}
        <div className="flex-auto">
          <label htmlFor="currency" className="font-bold block mb-2">{t('regiao')}</label>
          <Dropdown value={regiao} onChange={(e) => { setRegiao(e.value); setValidDocument(true) }} options={regioesTrt} optionLabel="name"
            placeholder="Selecione o Região" optionValue='code' className="w-full md:w-14rem" />
        </div>
      </>
    }

    if ((node.pickList && selectedKeys && ((selectedFilter && selectedFilter.key === node.key) || (Object.getOwnPropertyNames(selectedKeys)?.includes(node.key))))) {
      content = <>{content}
        {content && <br />}
        <PickList dataKey="value" onChange={(e) => { onChange(e, node.key) }} itemTemplate={pickItemTemplate} showSourceControls={false} showTargetControls={false} source={node.pickList.filter((s: any) => { return targets.filter((s: any) => s.value === node.key)[0].target.filter((s2: any) => s.value === s2.value).length == 0 })} target={targets.filter((s: any) => s.value === node.key)[0].target} filter filterBy="label"
          sourceHeader="Indicadores" targetHeader="Selecionados" sourceStyle={{ height: '24rem' }} targetStyle={{ height: '24rem' }}
          sourceFilterPlaceholder="Busca" targetFilterPlaceholder="Busca" />
      </>
    }

    if (((selectedFilter && selectedFilter.key === node.key) || (selectedKeys && Object.getOwnPropertyNames(selectedKeys)?.includes(node.key))) && node.filtros && node.filtros.filter((s1: any) => s1.tipoFiltro === 'DATA_NASCIMENTO').length > 0) {
      content = <>{content}
        {content && <br />}
        <div className="flex-auto">
          <label htmlFor="currency" className="font-bold block mb-2">{t('dataNascimento')}</label>
          <Calendar
            id="dataFinal"
            value={dataNascimento}
            onChange={(e) => { setDataNascimento(e.value); setValidDocument(true) }}
            showIcon
            dateFormat="dd/mm/yy"
            locale="pt"
          />
        </div>
      </>
    }

    if (content) {
      return <Fieldset onClick={(e) => e.stopPropagation()} legend={node.label}>{content}</Fieldset>
    }

    return label
  }

  useEffect(() => {
    setOptions(createOptions())
  }, [])

  return (<>
    <Panel header={t('consultaPF')}>
      <div className=" p-fluid flex flex-wrap gap-3">
        <div className="flex-auto">
          <label htmlFor="cpf" className="font-bold block mb-2 required">CPF</label>
          <InputMask id="cpf" value='cpf' onBlur={(e) => { setCpf(e.target.value); validCPF(e.target.value) }} mask="999.999.999-99" placeholder="999.999.999-99" required></InputMask>
        </div>
        <br></br>
        <div className=" p-fluid flex flex-wrap gap-3">
          <Tree filter filterMode="lenient" nodeTemplate={nodeTemplateRadio} expandIcon={undefined} collapseIcon={undefined} expandedKeys={expandAll(createOptions())} value={options} selectionKeys={selectedKeys} onSelectionChange={(e) => { setSelectedKeys(e.value); }} style={{ border: 'none', marginLeft: '-2.0rem', background: 'transparent' }} />
        </div>
        {opcionais && opcionais.length > 0 && (
          <div className=" p-fluid flex flex-wrap gap-3">
            <Divider className="automotiva" align="left">
              <div className="flex-score justify-content-between justify-content-center">
                <span
                  className="p-tag"
                  style={{
                    position: "relative",
                    backgroundColor: "#183462",
                    fontSize: "1.1rem",
                    height: "2rem",

                  }}
                >
                  Opcionais
                </span>
              </div>
            </Divider>
            <Tree nodeTemplate={nodeTemplate} expandIcon={undefined} collapseIcon={undefined} expandedKeys={expandAll(opcionais)} value={opcionais} selectionMode='checkbox' selectionKeys={selectedKeys} onSelectionChange={(e) => { buscarFiltro(e.value); setSelectedKeys(e.value); }} style={{ border: 'none', marginLeft: '-2.0rem', background: 'transparent' }} />
          </div>
        )}


      </div>
    </Panel>

    {/* Footer sempre visível */}
    <div style={{
      position: 'sticky',
      bottom: 0,
      backgroundColor: '#f9fafb',
      borderTop: '1px solid #ddd',
      padding: '1rem',
      display: 'flex',
      justifyContent: 'flex-end',
      boxShadow: '0 -2px 4px rgba(0,0,0,0.1)',
      marginTop: 'auto'
    }}>
      <Button
        disabled={!validDocument}
        style={{ backgroundColor: '#183462' }}
        label="Consultar"
        onClick={processConsulta}
      />
    </div>

  </>
  )
}